import React, { FC, useEffect, useState } from 'react';
import styles from './diff-words__item.module.scss';
import { Card, CardMedia, CardContent, Typography, IconButton, Box, Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { IUserWord, wordsResponse } from '../../../types';
import { useActions } from '../../../../../hooks/useAction';
import { useTypedSelector } from '../../../../../hooks/useTypesSelector';
import { updateLearnWord } from '../../../helpers';

interface DiffWordItemProps {
  words: wordsResponse | null;
  userWords: IUserWord;
}

export const DiffWordItem: FC<DiffWordItemProps> = ({ words, userWords }) => {
  const { userId } = useTypedSelector((state) => state.auth.user);
  const [isActive, setIsActive] = useState(false);
  const { fetchUpdateUserWord, fetchAllDiffWords } = useActions();
  const imageURL = `${process.env.REACT_APP_API_URL}${words?.image}`;

  useEffect(() => {}, [isActive]);

  const removeWord = async () => {
    if (words) {
      setIsActive(() => true);
      const diffOptions = updateLearnWord(userWords);
      await fetchUpdateUserWord(userId, words._id, diffOptions, `${words.group}`, `${words.page}`);
      await fetchAllDiffWords(userId);
    }
  };

  return (
    <div className={styles.item}>
      <Card sx={{ maxWidth: 345, minHeight: 600 }}>
        <CardMedia
          component="img"
          alt={words?.word}
          height="140"
          sx={{ maxHeight: 230, minHeight: 230 }}
          image={imageURL}
        />
        <div className={styles.content}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {words?.word}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h5" color="text.secondary">
                {words?.transcription}
              </Typography>
              <IconButton aria-label="play/pause">
                <PlayArrowIcon sx={{ height: 38, width: 38 }} />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: 250,
                fontSize: 16,
              }}
            >
              <Box>
                <Typography variant="body1">Значение</Typography>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: words?.textMeaning || '' }}
                ></Typography>
                <Typography variant="body2">{words?.textExampleTranslate}</Typography>
              </Box>
              <Box>
                <Typography variant="body1">Пример</Typography>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: words?.textExample || '' }}
                ></Typography>
                <Typography variant="body2">{words?.textExampleTranslate}</Typography>
              </Box>
              <div className={styles.wrapper_btn}>
                <Button onClick={removeWord}>Удалить из списка</Button>
              </div>
            </Box>
          </CardContent>
        </div>
      </Card>
    </div>
  );
};
